<template>
  <div class="content-item">
    <div class="flex">
      <div class="content-item-label"><span class="red">*</span>上传视频</div>
      <div
        class="item-video-wrap"
        v-loading="videoLoading"
        element-loading-text="视频正在转码..."
        style="width: 650px; height: 350px"
      >
        <video-player
          v-if="playerOptions.sources[0].src"
          class="vjs-default-skin vjs-big-play-centered video"
          ref="videoPlayer"
          :options="playerOptions"
          :playsinline="true"
        >
        </video-player>
      </div>
    </div>
    <div class="tips">*注：只支持MP4格式，最大500M，上传时长约3-4分钟</div>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import { request } from "@/utils/axios";
import "video.js/dist/video-js.css";
export default {
  name: "videoPlayMan",
  props: ["form", "functionIds"],
  data() {
    return {
      videoLoading: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src: "", // url地址
          },
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
    };
  },
  components: {
    videoPlayer,
  },
  methods: {
    displayDataToHtml() {
      if (
        this.form.articleVideoInfos &&
        this.form.articleVideoInfos.length > 0
      ) {
        // 返显视频封面
        this.showVideoAndVideoPic(this.form);
        // 后台视频未上传完毕
        if (this.form.articleVideoInfos[0].playUrl === undefined) {
          this.videoLoading = true;
          // 视频文件后台没有及时返回, 需要重复获取
          this.videoInterval = setInterval(() => {
            request(this.functionIds.getArticleByPid, {
              id: this.form.id,
              tenantId: this.$commonJs.getTenantId(),
            }).then((res1) => {
              if (res1.articleVideoInfos[0].playUrl) {
                clearInterval(this.videoInterval);
                this.form.articleVideoInfos = res1.articleVideoInfos;
                this.showVideoAndVideoPic(res1);
                this.videoLoading = false;
              }
            });
          }, 1000);
        } else {
          // 运营端展示视频播放器： 赋值视频
          this.playerOptions.sources[0].src =
            this.form.articleVideoInfos[0].playUrl;
        }
      }
    },
    showVideoAndVideoPic(res) {
      // 如果没有上传视频文件，该对象为空。
      if (!res.articleVideoInfos || !res.articleVideoInfos.length) {
        return;
      }
      //返显视频封面
      if (res.articleVideoInfos[0].imageUrl) {
        let imageUrl = "";
        this.uploadVideoPicSuccess = true;
        if (
          /(http|https):\/\/([\w.]+\/?)\S*/.test(
            res.articleVideoInfos[0].imageUrl
          )
        ) {
          imageUrl = res.articleVideoInfos[0].imageUrl;
        } else {
          imageUrl = this.imgHost + res.articleVideoInfos[0].imageUrl;
        }
        this.playerOptions.poster = imageUrl;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item-video-wrap {
  position: relative;
  width: 520px;
  height: 290px;
  :deep(.video) {
    width: 100%;
    height: 100%;
    .video-js {
      width: 100%;
      height: 100%;
    }
  }

  :deep(.vjs-big-play-button) {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
  }
}
</style>
